module.exports = [
  {
    id: 1,
    name: 'Не рассмотрено экспертом'
  },
  {
    id: 2,
    name: 'Принято'
  },
  {
    id: 3,
    name: 'Неинформативный отзыв'
  },
  {
    id: 4,
    name: 'Ошибка врача'
  },
  {
    id: 5,
    name: 'Учтено для развития системы '
  }
]
